export default __webpack_public_path__ + "static/media/happy-dog.47657c29.png";